import { render, staticRenderFns } from "./TableMultiple.vue?vue&type=template&id=4853c25e&scoped=true"
import script from "./TableMultiple.vue?vue&type=script&lang=js"
export * from "./TableMultiple.vue?vue&type=script&lang=js"
import style0 from "./TableMultiple.vue?vue&type=style&index=0&id=4853c25e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853c25e",
  null
  
)

export default component.exports